<template>
  <div
    class="tw-flex tw-items-center tw-py-6 tw-gap-6 hover:tw-bg-light dark:hover:tw-bg-dm-light tw-px-6"
  >
    <div
      class="tw-flex tw-items-center"
      :style="`width: ${columns[0].width}`"
    >
      {{ document.name }}
    </div>

    <div :style="`width: ${columns[1].width}`">
      {{ document.description }}
    </div>

    <div :style="`width: ${columns[2].width}`">
      <i-badge
        :type="document.editable_by_client ? 'success' : 'default'"
        class="tw-w-fit"
      >
        {{ document.editable_by_client ? $t('common.values.yes') : $t('common.values.no') }}
      </i-badge>
    </div>

    <div :style="`width: ${columns[3].width}`">
      <i-badge
        :type="document.editable_by_foreigner ? 'success' : 'default'"
        class="tw-w-fit"
      >
        {{ document.editable_by_foreigner ? $t('common.values.yes') : $t('common.values.no') }}
      </i-badge>
    </div>

    <div :style="`width: ${columns[4].width}`">
      <div
        class="tw-flex tw-items-center tw-gap-2"
      >
        <i-button
          type="white"
          is-icon
          @click="isEditDocumentDialogOpen = true"
        >
          <icon-edit />
        </i-button>
        <i-confirm-popover
          :cancel-text="$t('common.actions.cancel')"
          :submit-text="$t('common.actions.delete')"
          @submit="deleteDocument"
        >
          <template #reference>
            <i-button
              type="white"
              is-icon
              class="tw-text-primary"
              :is-loading="isDeleting"
            >
              <icon-trash />
            </i-button>
          </template>
          <template #content>
            <div slot="content">
              {{ $t('adm.permits.documents.delete_documents_dialog.confirm_text') }}
              {{ document.name }}
            </div>
          </template>
        </i-confirm-popover>
      </div>
    </div>
    <EditPermitDocumentDialog
      :is-open="isEditDocumentDialogOpen"
      :document-id="document.id"
      @close="isEditDocumentDialogOpen = false"
    />
  </div>
</template>

<script>

import { getValidationError } from '@/helpers';
import EditPermitDocumentDialog from '@/components/Administration/PermitManagement/Documents/EditPermitDocumentDialog.vue';

export default {
  name: 'PermitDocumentListItem',
  components: { EditPermitDocumentDialog },
  props: {
    document: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isEditDocumentDialogOpen: false,
      isDeleting: false,
    };
  },

  methods: {
    async deleteDocument() {
      this.isDeleting = true;
      try {
        await this.$store.dispatch('v2/admin/cms/permitManagement/documents/deleteDocument', this.document.id);
      } catch (e) {
        this.$message.error({
          message: this.$capitalize(e.response.data.message),
          showClose: true,
        });
      } finally {
        this.isDeleting = false;
      }
    },
  },
};
</script>
